import { searchOnlyNavItems } from "src/app/layouts/full/vertical/sidebar/sidebar-data";
import { NavItem } from "src/app/layouts/full/vertical/sidebar/nav-item/nav-item";

/**
 * Recursively flatten nav items to get all navigable items.
 */
export function flattenNavItemsForSearch(items: NavItem[]): NavItem[] {
  const result: NavItem[] = [];

  items.forEach((item) => {
    if (item.block === true && !(item.children && item.children.length)) {
      return;
    }

    if (item.children && item.children.length > 0) {
      result.push(...flattenNavItemsForSearch(item.children));
    }

    if (item.route && item.displayName && item.block !== true) {
      result.push(item);
    }
  });

  return result;
}

export function getSearchableNavItems(navItems: NavItem[]): NavItem[] {
  return [...flattenNavItemsForSearch(navItems), ...searchOnlyNavItems];
}

export function filterNavItemsForSearch(
  items: NavItem[],
  searchText: string,
): NavItem[] {
  if (!searchText || searchText.trim() === "") {
    return [];
  }

  const searchLower = searchText.toLowerCase();

  return items.filter((item) => {
    if (item.displayName?.toLowerCase().includes(searchLower)) {
      return true;
    }

    if (
      item.tags &&
      item.tags.some((tag) => tag.toLowerCase().includes(searchLower))
    ) {
      return true;
    }

    return false;
  });
}
